import Model from '@/models/Model.js';

export default class RubricCriteriaRating extends Model {
    static entity = 'rubric_criteria_ratings';

    static modelName = 'RubricCriteriaRating';

    static fields() {
        return {
            id: this.attr(null),
            rubric_criteria_id: this.attr(null),
            value: this.attr(null),
            label: this.attr(null),
            description: this.attr(null),

            ...super.fields(),
        };
    }
}
